import store from './../store'

// Company job postings — business admins only. Tradies (supervisor tradies
// included) get page-not-found here; project-scoped business admins are also
// turned away (the router guard's permission gate already bounces them since
// their role holds no jobs.* keys — this is a second, explicit check).
// Order matters: /jobs/new and /jobs/:jobId/edit are declared before
// /jobs/:jobId so "new" isn't read as a job id.
function isAllowed(user) {
  if (!user || user.user_type !== 'business_admin') return false
  return !store.getters['auth/isProjectScoped']
}

export default {
  path: '/jobs',
  name: 'jobs',
  redirect: { name: 'jobs.list-page' },
  component: () => import('@/views/jobs/index.vue'),
  children: [
    {
      path: '/jobs',
      name: 'jobs.list-page',
      component: () => import('@/views/jobs/ListPage.vue'),
    },
    {
      path: '/jobs/new',
      name: 'jobs.new-page',
      component: () => import('@/views/jobs/FormPage.vue'),
    },
    {
      path: '/jobs/:jobId/edit',
      name: 'jobs.edit-page',
      component: () => import('@/views/jobs/FormPage.vue'),
    },
    {
      path: '/jobs/:jobId',
      name: 'jobs.view-job',
      component: () => import('@/views/jobs/ViewJob.vue'),
    },
  ],
  beforeEnter: async (to, from, next) => {
    if (store.state.auth.user) {
      return isAllowed(store.state.auth.user)
        ? next()
        : next({ name: 'page-not-found' })
    }
    store
      .dispatch('auth/getAuthenticatedUser')
      .then(() => {
        if (isAllowed(store.state.auth.user)) next()
        else next({ name: 'page-not-found' })
      })
      .catch(() => next({ name: 'auth.login-page' }))
  },
}
